import { Languages } from "@ribondao/shared/types";

export const countryListEnglish = [
  "Afghanistan",
  "Albania",
  "Algeria",
  "Andorra",
  "Angola",
  "Argentina",
  "Armenia",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bhutan",
  "Bolivia",
  "Bosnia-Herzegovina",
  "Botswana",
  "Brazil",
  "Brunei",
  "Bulgaria",
  "Burkina",
  "Burma",
  "Burundi",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Cape Verde Islands",
  "Chad",
  "Chile",
  "China",
  "Colombia",
  "Congo",
  "Costa Rica",
  "Croatia",
  "Cuba",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "England",
  "Eritrea",
  "Estonia",
  "Ethiopia",
  "Fiji",
  "Finland",
  "France",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Great Britain",
  "Greece",
  "Grenada",
  "Guatemala",
  "Guinea",
  "Guyana",
  "Haiti",
  "Holland",
  "Honduras",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Israel",
  "Italy",
  "Japan",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Korea",
  "Kuwait",
  "Laos",
  "Latvia",
  "Lebanon",
  "Liberia ",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxenbourg",
  "Macedonia",
  "Madasgascar",
  "Malawi",
  "Malaysia",
  "Mali",
  "Malta",
  "Maldives",
  "Mauritania",
  "Mauritius",
  "Mexico",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Morocco",
  "Mozambique",
  "Namibia",
  "New Zealand ",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "North Korea",
  "Norway",
  "Oman",
  "Pakistan",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Puerto Rico",
  "Qatar",
  "Romania",
  "Russia",
  "Rwanda",
  "Saudi Arabia",
  "Scotland",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Korea",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Swaziland",
  "Sweden",
  "Switzerland",
  "Syria",
  "Taiwan",
  "Tanzania",
  "Thailand",
  "Togo",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom (UK)",
  "United States of America (USA)",
  "Uruguay",
  "Uzbekistan ",
  "Vanuatu",
  "Vatican",
  "Venezuela",
  "Vietnam",
  "Western Samoa",
  "Yemen ",
  "Yugoslavia ",
  "Zaire",
  "Zambia",
  "Zimbabwe",
];

export const countryListPtBr = [
  "Afeganistão",
  "Albânia",
  "Argélia",
  "Andorra",
  "Angola",
  "Argentina",
  "Armênia",
  "Austrália",
  "Áustria",
  "Azerbaijão",
  "Bahamas",
  "Barém",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Bélgica",
  "Belize",
  "Benin",
  "Butão",
  "Bolívia",
  "Bósnia e Herzegovina",
  "Botsuana",
  "Brasil",
  "Brunei",
  "Bulgária",
  "Burkina",
  "Birmânia",
  "Burundi",
  "Camboja",
  "Camarões",
  "Canadá",
  "Ilhas de Cabo Verde",
  "Chade",
  "Chile",
  "China",
  "Colômbia",
  "República do Congo",
  "Costa Rica",
  "Croácia",
  "Cuba",
  "Chipre",
  "República Checa",
  "Dinamarca",
  "Djibuti",
  "Dominica",
  "República Dominicana",
  "Equador",
  "Egito",
  "El Salvador",
  "Inglaterra",
  "Eritreia",
  "Estônia",
  "Etiópia",
  "Fiji",
  "Finlândia",
  "França",
  "Gabão",
  "Gâmbia",
  "Georgia",
  "Alemanha",
  "Gana",
  "Grã Bretanha",
  "Grécia",
  "Grenada",
  "Guatemala",
  "Guiné",
  "Guiana",
  "Haiti",
  "Holanda",
  "Honduras",
  "Hungria",
  "Islândia",
  "Índia",
  "Indonésia",
  "Irã",
  "Iraque",
  "Irlanda",
  "Israel",
  "Itália",
  "Japão",
  "Jordânia",
  "Cazaquistão",
  "Quênia",
  "Coreia",
  "Kuwait",
  "Laos",
  "Letônia",
  "Líbano",
  "Libéria",
  "Líbia",
  "Liechtenstein",
  "Lituânia",
  "Luxemburgo",
  "Macedônia",
  "Madagascar",
  "Malawi",
  "Malásia",
  "Mali",
  "Malta",
  "Ilhas Maldivas",
  "Mauritânia",
  "Maurício",
  "México",
  "Moldávia",
  "Mônaco",
  "Mongólia",
  "Montenegro",
  "Marrocos",
  "Moçambique",
  "Namíbia",
  "Nova Zelândia",
  "Nicarágua",
  "Níger",
  "Nigéria",
  "Coreia do Norte",
  "Noruega",
  "Omã",
  "Paquistão",
  "Panamá",
  "Papua Nova Guiné",
  "Paraguai",
  "Peru",
  "Filipinas",
  "Polônia",
  "Portugal",
  "Porto Rico",
  "Catar",
  "Romênia",
  "Rússia",
  "Ruanda",
  "Arábia Saudita",
  "Escócia",
  "Senegal",
  "Sérvia",
  "Seychelles",
  "Serra Leoa",
  "Cingapura",
  "Eslováquia",
  "Eslovênia",
  "Ilhas Salomão",
  "Somália",
  "África do Sul",
  "Coreia do Sul",
  "Espanha",
  "Sri Lanka",
  "Sudão",
  "Suriname",
  "Suazilândia",
  "Suécia",
  "Suíça",
  "Síria",
  "Taiwan",
  "Tanzânia",
  "Tailândia",
  "Togo",
  "Trindade e Tobago",
  "Tunísia",
  "Turquia",
  "Turcomenistão",
  "Tuvalu",
  "Uganda",
  "Ucrânia",
  "Emirados Árabes Unidos",
  "Reino Unido",
  "Estados Unidos da América (EUA)",
  "Uruguai",
  "Uzbequistão",
  "Vanuatu",
  "Vaticano",
  "Venezuela",
  "Vietnã",
  "Samoa Ocidental",
  "Iêmen",
  "Jugoslávia",
  "Zaire",
  "Zâmbia",
  "Zimbábue",
];

export const countryList = (currentLang: Languages) =>
  currentLang === Languages.PT ? countryListPtBr : countryListEnglish;
